import { useTranslation } from 'react-i18next';
import {
  TaskCheckmarkFilledNew,
  StartFlag,
  PersonInfo,
  Blocks,
} from '@teo/components/icons';
import { ProgressBar, Button } from '@teo/components';
import { useEffect, useState, useContext } from 'react';
import { sortDataLP } from '@/components/LearningPath/util';
import { axios } from '@/axios';
import { config } from '@/config';
import { AuthContext } from '@/components/Contexts/AuthContext';
import { nthLastIndexOf, renderTemplate, nthIndexOf } from '@/util';
import { useParams, useNavigate } from 'react-router-dom';
import { LearnContent } from '@/components/LearningPath/Learn/LearnContent';

export const MilestonesContent = ({
  authUser,
  training,
  trainingId,
  allMilestones,
  beforeMilestones,
  nextMilestone,
  allNodes,
  mlsFollow = {},
  isUserFollow = false,
  preview = false,
  allBeforeDone = false,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const originPath = window.location.pathname.slice(
    0,
    nthLastIndexOf(window.location.pathname, '/', 2)
  );

  const basePath = window.location.pathname.slice(
    0,
    nthIndexOf(window.location.pathname, '/', 1)
  );
  return (
    <>
      <div className="relative -mt-4 h-[520px] w-full overflow-hidden bg-grey-01">
        <div className="relative flex h-[520px] overflow-hidden">
          <div className="z-1 absolute h-full w-full bg-gradient-to-b from-black"></div>
          <img
            src={training?.trainingPicture || '/assets/images/LearnPath.png'}
            alt={training?.trainingPicture}
            className="inline h-[520px] w-full object-cover"
          />
        </div>
      </div>
      <div className="my-8 mx-auto flex w-full max-w-[720px] flex-col px-0 sm:px-4">
        <div className="flex w-full flex-col border-b px-4 sm:px-0">
          <p className="text-sm capitalize text-grey-05">
            {t('pages.lp_landing.milestone')}
          </p>
          <h3 className="mt-1 text-xl">{training?.trainingName}</h3>
          <div className="my-4 flex w-full flex-row items-center gap-2 ">
            {allMilestones?.map((el) => {
              return (
                <div key={el.id} className="flex w-full items-center gap-2">
                  <ProgressBar
                    max={100}
                    value={el?.isCompleted ? 100 : 0}
                    className="progress-bar__all h-1 overflow-hidden rounded-lg"
                  />
                  {el?.typeOfTraining === 'certificate' ? (
                    <TaskCheckmarkFilledNew
                      className={`h-5 w-5 ${
                        el?.isCompleted ? 'text-black' : 'text-grey-04'
                      }`}
                    />
                  ) : el?.typeOfTraining === 'endpoint' ? (
                    <StartFlag
                      className={`h-5 w-5 ${
                        el?.isCompleted ? 'text-black' : 'text-grey-04'
                      }`}
                    />
                  ) : (
                    <PersonInfo
                      className={`h-5 w-5 ${
                        el?.isCompleted ? 'text-black' : 'text-grey-04'
                      }`}
                    />
                  )}
                </div>
              );
            })}
            <span className="pl-3 text-xs text-grey-06">
              {Math.round(
                ((beforeMilestones?.length + 1) / allMilestones?.length) * 100
              )}
              %
            </span>
          </div>

          {training?.motivationalMessage && (
            <p className="text-grey-08">
              {renderTemplate(training?.motivationalMessage, {
                first_name: authUser?.firstName,
                last_name: authUser?.lastName,
              })}
            </p>
          )}
          {nextMilestone && (
            <p className="mt-4 text-grey-08">
              {t('pages.landing_training.next_milestone')}
              <span className="ml-1 font-semibold">{nextMilestone?.name}</span>
            </p>
          )}
          <div className="my-8 flex gap-3 ">
            {preview ? (
              <Button>{t('pages.landing_training.continue_learning')}</Button>
            ) : (
              <Button
                disabled={!allBeforeDone}
                onClick={() => {
                  if (isUserFollow) {
                    if (mlsFollow?.status === 'completed') {
                      navigate(`${originPath}`);
                    } else {
                      const promises = [];
                      promises.push(
                        axios.put(
                          `${config.backend}/trainingfollow/${trainingId}/${authUser?.id}`,
                          {
                            progress: 1,
                            status: 'completed',
                            isCorrected: true,
                          }
                        )
                      );
                      Promise.allSettled(promises).then(() => {
                        navigate(`${originPath}`);
                      });
                    }
                  } else {
                    const promises = [];
                    promises.push(
                      axios.post(`${config.backend}/trainingfollows`, {
                        trainingId: trainingId,
                        userId: authUser?.id,
                        progress: 1,
                        status: 'completed',
                        isCorrected: true,
                      })
                    );
                    Promise.allSettled(promises).then(() => {
                      navigate(`${originPath}`);
                    });
                  }
                }}
              >
                {t('pages.landing_training.continue_learning')}
              </Button>
            )}
            {training?.typeOfTraining === 'certificate' && (
              <Button
                variant="secondary"
                onClick={() =>
                  !preview &&
                  navigate(`${basePath}/profile/details?view=certificates`)
                }
              >
                {t('pages.landing_training.view_certificates')}
              </Button>
            )}
          </div>
        </div>
        {/* <div className="flex w-full flex-col border-b py-8 px-4 sm:px-0">
          <h3 className="mb-4 text-base">
            {t('pages.landing_training.your_achievements')}
          </h3>
          <div className="mb-4 flex flex-col gap-3 rounded-lg border p-5">
            <Blocks className="h-6 w-6 text-grey-08" />
            <h4 className="text-base font-medium">
              Your average score overall is 87%. Impressive!
            </h4>
            <p className="text-sm text-grey-05">
              This is 11% above your company’s average.
            </p>
          </div>
          <div className=" flex flex-col gap-3 rounded-lg border p-5">
            <TaskCheckmarkFilledNew className="h-6 w-6 text-grey-08" />
            <h4 className="text-base font-medium">
              You are now a safety expert
            </h4>
            <p className="text-sm text-grey-05">
              Your score on safety related questions is among the highest in
              your company.
            </p>
          </div>
        </div> */}
        {allNodes?.length > 0 && (
          <div className="flex w-full flex-col py-8 px-4 sm:px-0">
            <h3 className="mb-4 text-base">
              {t('pages.landing_training.successfully_completed')}
            </h3>
            <LearnContent allNodes={allNodes} />
          </div>
        )}
      </div>
    </>
  );
};
